import logo from './logo.svg';
import './App.css';
import AllRoutes from "./pages/allRoutes"

function App() {
  return (
    <div className="App">
      <AllRoutes/>
    </div>
  );
}

export default App;
